import {Component, OnInit,} from '@angular/core';

import {LoginHelper, Role} from '../../helpers';

import {Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService,} from '../../_services/index';

import {User,} from '../../_models/index';


import {IndexConfigService} from "../../_services/index.config.service";


@Component({
    standalone: false,
  selector: "documents",
  templateUrl: 'documents.component.html'
})

export class DocumentsComponent implements OnInit {
  model: any = {};
  loading = false;
  currentUser: User;
  isRealUser = false;

  constructor(public router: Router,
              public userService: UserService,
              public alertService: AlertService,
              //@Inject(FileManagerConfiguration) public configuration: IFileManagerConfiguration,
              public authenticationService: AuthenticationService,
              //public fileManagerDispatcher: FileManagerDispatcherService,
              public config: IndexConfigService) {

    //this.fileManagerDispatcher.unSelectAllFiles();
  }

  ngOnInit() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isRealUser = (currentUser.role & (Role.Survey | Role.Training | Role.Vendor)) === 0;

    /*this.configuration.urls.foldersUrl = this.config.api + '/api/documents/foldersAll',
    this.configuration.urls.folderMoveUrl = this.config.api + '/api/documents/folderMove'
    this.configuration.urls.filesUrl = this.config.api + '/api/documents/filesAll';*/
  }
}
